<template>
    <div>
        <kgr-lightbox
            :value="show"
            :headline="$t('Warenkorb')"
            animated
        >
            <kgr-loading
                v-if="pending"
                inline
            />
            <div v-else>
                <kgr-club-sales-list-items
                    :club-sales-list-items="fees"
                    with-total-price
                    is-aggregated
                />
                <div
                    v-if="isPaymentAvailable"
                    class="kgr-row"
                >
                    <kgr-payment-method-select
                        v-model="paymentMethod"
                        :options="paymentMethodOptions"
                    />
                </div>
                <div
                    v-else
                    class="kgr-row"
                >
                    {{ $t('Es wurde keine mögliche Zahlungsmethode hinterlegt') }}
                </div>
                <div class="kgr-row">
                    <kgr-button
                        :value="$t('Buchung abschließen')"
                        :disabled="pending || !isPaymentAvailable || paymentMethod === null"
                        @click="onConfirm"
                    />
                    <kgr-button
                        type="grey"
                        :value="$t('cancel')"
                        :disabled="pending"
                        @click="onClose"
                    />
                </div>
            </div>
            <kgr-confirm
                ref="confirmExecute"
                :headline="$t('Kartenzahlung')"
            >
                <div>
                    {{ $t('War der Bezahlvorgang erfolgreich?') }}
                </div>
            </kgr-confirm>
        </kgr-lightbox>
    </div>
</template>

<script>
import ClubSalesListConfig from '../../../js/dto/ClubSalesListConfig.js';
import ClubSalesListItems from '../../club/sales-list/ClubSalesListItems.vue';
import ConfirmDialog from '../../common/modal/ConfirmDialog.vue';
import Error from '../../../js/model/Error.js';
import KgrButton from '../../common/form/button/KgrButton.vue';
import Lightbox from '../../common/modal/Lightbox.vue';
import Loading from '../../common/Loading.vue';
import Money from '../../../js/dto/Money.js';
import PaymentMethodSelect from '../../common/form/select/PaymentMethodSelect.vue';

export default {
    components: {
        'kgr-confirm': ConfirmDialog,
        'kgr-button': KgrButton,
        'kgr-lightbox': Lightbox,
        'kgr-loading': Loading,
        'kgr-club-sales-list-items': ClubSalesListItems,
        'kgr-payment-method-select': PaymentMethodSelect,
    },
    props: {
        clubSalesListConfig: {
            type: ClubSalesListConfig,
            required: true,
        },
        hasSepaDebit: {
            type: Boolean,
            required: true,
        },
        isCreditPaymentAvailable: {
            type: Boolean,
            required: true,
        },
        remainingMemberCredit: {
            type: Money,
            required: true,
        },
        show: {
            type: Boolean,
            required: true,
        },
        fees: {
            type: Array,
            required: true,
        },
        pending: {
            type: Boolean,
            required: true,
        },
        pendingInvoicing: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            error: new Error(),
            paymentMethod: null,
            useCredit: false,
        };
    },
    computed: {
        paymentMethodOptions() {
            return this.clubSalesListConfig.paymentMethods.map((method) => {
                const value = method.value;
                let isDisabled = false;
                let label = method.label;
                if (method.value === 'sepa-debit' && !this.hasSepaDebit) {
                    isDisabled = true;
                    label += ` (${this.$t('Nicht verfügbar')})`;
                }
                if (method.value === 'member-credit') {
                    label += ` (${this.$t('Verfügbar: {credit}', { credit: this.remainingMemberCredit.toLocalizedString() })})`;
                    if (!this.isCreditPaymentAvailable) {
                        isDisabled = true;
                        if (this.pendingInvoicing) {
                            label = `${method.label} (${this.$t('Abrechnung läuft')})`;
                        }
                    }
                }
                return { value, label, disabled: isDisabled };
            });
        },
        isPaymentAvailable() {
            return this.paymentMethodOptions.length > 0;
        },
        checkoutData() {
            return {
                paymentMethod: this.paymentMethod,
                clubFees: this.fees.map((f) => f.id),
            };
        },
    },
    methods: {
        async onConfirm() {
            let confirmed = true;
            if (this.paymentMethod === 'debit-card') {
                confirmed = await this.$refs.confirmExecute.open();
            }

            if (confirmed) {
                this.$emit('onConfirm', this.checkoutData);
            }
        },
        onClose() {
            this.$emit('onClose');
        },
    },
};
</script>

<style scoped lang="scss" rel="stylesheet/scss"></style>
